import { useQuery } from '@tanstack/react-query';

import Axios from '@/lib/axios-instance';

type Props = {
  skip: number;
  limit: number;
  search?: string | null;
};

export const getStorewiseLeads = async (skip: number, limit: number, search?: string | null) => {
  try {
    let url = `/lead?skip=${skip}&limit=${limit}`;
    if (search) {
      url += `&search=${search}`;
    }
    const response = await Axios.get(url);
    return response.data;
  } catch (error: any) {
    if (error.response) {
      throw new Error(
        `${error.response.data?.meta?.message || 'An error occurred'}`,
      );
    }
    throw new Error(error.message || 'Network Error');
  }
};

export const useGetStorewiseLeads = ({ skip, limit, search }: Props) => {
  const questions = useQuery({
    queryKey: ['get_storewise_leads', skip, limit, search],
    queryFn: () => getStorewiseLeads(skip, limit, search),
  });

  return questions;
};
